import { CSSProperties } from "react";
import { filterCSSProps, toKebabCase } from "shared/utils/styledComponentUtils";
import styled, { css } from "styled-components";

export const Flex = styled.div<CSSProperties>`
display: flex;
  ${(props) =>
    css`
      ${Object.entries(filterCSSProps(props))
        .map(([key, value]) => `${toKebabCase(key)}: ${value};`)
        .join("\n")}
    `}
`;